module.exports = __webpack_public_path__ + "static/media/partner-image-04.86873ccb.svg";